import Vue from 'vue'
import { VueMaskDirective } from 'v-mask'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'

// import '@mdi/font/css/materialdesignicons.min.css'

Vue.config.productionTip = false
Vue.directive('mask', VueMaskDirective)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
